export class ProcessoProdutoSetorModelNovo {
   constructor(
      public ids: Array<string> = [],
      public produtosImpresso: boolean = false
   ) { }
}